import { getApplicationId, getIsSalesForce } from '@fnol/library/src/lib';
import { translations } from './consts';
import { FirstMessage } from '../components/IntroMessages/FirstMessage';
import { SecondMessage } from '../components/IntroMessages/SecondMessage';

const stepsComposer = () => [
    {
        path: '/stepOne',
        screen: getIsSalesForce(getApplicationId()) ? SecondMessage : FirstMessage,
        step: 0,
        label: getIsSalesForce(getApplicationId())
            ? translations.stepLabel.INTRO_CONFIRMATION
            : translations.stepLabel.INTRO_START,
    },
    {
        path: '/stepTwo',
        screen: SecondMessage,
        step: 1,
        label: translations.stepLabel.INTRO_CONFIRMATION,
    },
];

export default stepsComposer;
